import { createRoot } from 'react-dom/client';

import './index.css';
import '@ads/components-react/dist/Linka-styles.css';
import './i18n.ts';
import '../api/setup';

import { RouterProvider } from 'react-router';
import { Providers } from './providers.tsx';
import router from './routes/router.tsx';

const container = document.getElementById('root') as HTMLElement;

createRoot(container).render(
  <Providers>
    <RouterProvider router={router} />
  </Providers>,
);
